import * as actions from '../../constants';
export var changeUserTeam = function changeUserTeam(teamId) {
  return {
    type: actions.USER_TEAM_CHANGE,
    currentTeam: teamId
  };
};